<template>
  <div ref="page" class="pwc-question-form" :style="cFormStyle">
    <pwc-container class="pwc-app-container">
      <div class="pwc-logo">
        <img src="../../../assets/logo.png">
      </div>
      <div v-if="!submited" class="pwc-form-title">
        <span>{{ data.Title }}</span>
      </div>
      <DyForm v-if="!submited" ref="dyform" :data="data" :form-data="formData" :file-keys="fileKeys" @submitForm="(val) => {submitForm(val)}" />
      <!-- <div v-if="!submited" class="pwc-form-privacy">
        <span>
          <a href="https://youplusapplication.businesstrainingshpwc.com/application/TermsOfUse.html">&nbsp;使用条款&nbsp;</a>和
          <a href="https://youplusapplication.businesstrainingshpwc.com/application/PrivacyStatement.html">&nbsp;隐私条款</a></span>
      </div> -->
      <pwc-thanks-info v-if="submited" />
    </pwc-container>
  </div>
</template>
<script>
import PwcContainer from '@/views/layout/desktop/PwcContainer'
import DyForm from '@/components/PwcDyForm/desktop'
import { http } from '@/api'
import { mapState } from 'vuex'
import { PublicEvent } from '@/api/collection'
import Detect from '@/util/detect'
const isMobile = Detect(window.navigator.userAgent).mobile()
import { Notify } from 'vant'
import PwcThanksInfo from '../common/thanks'
import { common } from '../common/mixin.js'

export default {
  name: 'CounsellingDesktop',
  components: {
    PwcContainer,
    DyForm,
    PwcThanksInfo
  },
  mixins: [common],
  data() {
    return {
      submited: false,
      submitData: {}
    }
  },
  computed: {
    cFormStyle() {
      if (isMobile) {
        return {
          'background-image': 'none'
        }
      }
      return {}
    },
    ...mapState(['loading', 'userInfo'])
  },

  methods: {
    async submitForm(val) {
      console.log('formData :', val)
      this.data.Questions.forEach(item => {
        if (item.type === 'fileupload') {
          this.submitData['resumeURL'] = val[item.key]
        }
        if (item.type === 'textarea') {
          this.submitData['category'] = val[item.key]
        }
      })
      this.submitData['leadId'] = this.userInfo.leadId
      const res = await http(
        {
          path: PublicEvent.ApplyForCounselling.path,
          method: PublicEvent.ApplyForCounselling.method,
          data: this.submitData
        }
      )
      if (res.resultCode === '0') {
        Notify({ message: '提交成功', duration: 3 * 1000 })
        this.submited = true
      }
    }
  }
}
</script>
<style lang="scss">
.pwc-question-form {
  font-family: 'Microsoft YaHei', Georgia, "Times New Roman", Times, serif;
  // overflow-y: auto;
  background-image: url("../../../assets/register-form-bg.jpg");
  background-attachment: fixed;
  min-height: 100vh;
  .pwc-app-container {
    margin-bottom: 0;
    margin-top: 0;
    padding-top: 36px;
    padding-bottom: 36px;
  }

  .pwc-form-title,
  .pwc-form-desc,
  .pwc-form-data,
  .pwc-form-action {
    margin: auto;
    max-width: 640px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #fff;
    padding-top: 24px;
  }

  .pwc-form-title {
    text-align: center;
    font-size: 18px;
    font-weight: normal;
    padding-top: 40px;
    padding-bottom: 20px;
  }

  .pwc-form-desc {
    text-align: left;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
  }

  .pwc-form-action {
    text-align: center;
    padding-bottom: 32px;
  }
}

.pwc-logo {
  margin: auto;
  box-sizing: border-box;
  position: relative;
  height: auto;
  width: auto;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  max-width: 640px;
  padding-top: 36px;

  img {
    width: 400px;
  }
}

.pwc-dialog-submit {
  padding: 22px;
  padding-top: 36px;
  padding-bottom: 6px;
}

.pwc-form-privacy {
  text-align: center;
  font-size: 16px;
  padding-top: 30px;
  padding-bottom: 15px;
  background-color: #fff;
  max-width: 640px;
  margin: auto;
  height: auto;
  width: auto;
  overflow: hidden;
}

@media all and (max-width: 960px) {
  .pwc-logo {
    margin: auto;
    box-sizing: border-box;
    position: relative;
    height: auto;
    width: auto;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 300px;
    }
  }
}
</style>
<style lang="scss">
.pwc-question-form {
  .theme--light.v-text-field.v-input--is-disabled
    > .v-input__control
    > .v-input__slot:before {
    border-image: none;
  }

  .v-text-field--box > .v-input__control > .v-input__slot {
    border-radius: 0;
  }

  .v-input--radio-group__input {
    .v-input--selection-controls {
      margin-top: 0;
    }

    .v-input__slot {
      margin-bottom: 4px;
    }

    .v-messages {
      display: none;
    }
  }
}
</style>
